import { useMutation, useQueryClient } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { BaseError, BaseResponse } from '@utils/types/shared/base.ts';
import { POST_URL } from '@utils/api/endpoints.ts';
import { AxiosError } from 'axios';

export type ResetPasswordResponse = BaseResponse<null>;

export function useResetResellerUserPassword(customerId: string) {
  const queryClient = useQueryClient();

  return useMutation<
    ResetPasswordResponse,
    AxiosError<BaseError>,
    { userId: number }
  >(
    async ({ userId }) => {
      const response = await Axios.put<ResetPasswordResponse>(
        POST_URL(customerId.toString(), userId.toString()).resetAPassword
      );
      return response.data;
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries('resellerCustomerLogin');
      }
    }
  );
}
